import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import SmallLoader from './SmallLoader';
import Typewriter from 'typewriter-effect';
import './ChatArea.css';
import { auth } from '../firebase-config'; // Import Firebase auth

// Custom LinkRenderer to open links in a new tab
const LinkRenderer = (props) => (
  <a href={props.href} target="_blank" rel="noopener noreferrer">
    {props.children}
  </a>
);

// Function to save chat history to your backend
const saveChat = async (chatMessage) => {
  const user = auth.currentUser;  // Get the logged-in user
  if (!user) {
    console.error("No user is logged in");
    return;
  }

  await fetch('/save_chat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_id: user.uid,  // Use Firebase UID to identify the user
      chat: chatMessage,  // Send the chat message to be saved
    }),
  });
};

function ChatArea({ messages, isAiLoading }) {
  const [showMarkdown, setShowMarkdown] = useState([]);

  useEffect(() => {
    // Reset showMarkdown state when a new message is added
    setShowMarkdown((prevState) => [...prevState, false]);
  }, [messages.length]);

  const handleTypewriterComplete = (index) => {
    setShowMarkdown((prevState) => {
      const newState = [...prevState];
      newState[index] = true;
      return newState;
    });
  };

  const handleSaveMessage = async (message) => {
    await saveChat(message); // Call saveChat when a new message is sent
  };

  return (
    <div className="chat-area">
      {messages.map((message, index) => (
        <div key={index} className={`message ${message.role}`}>
          {message.role === 'ai' && !showMarkdown[index] ? (
            <Typewriter
              options={{
                delay: 0,
              }}
              onInit={(typewriter) => {
                typewriter
                  .typeString(message.content)
                  .callFunction(() => {
                    handleTypewriterComplete(index);
                    handleSaveMessage(message.content);  // Save AI response to backend
                  })
                  .start();
              }}
            />
          ) : (
            <div className="markdown-content">
              <ReactMarkdown components={{ a: LinkRenderer }}>
                {message.content}
              </ReactMarkdown>
            </div>
          )}
        </div>
      ))}

      {isAiLoading && (
        <div className="message ai">
          <SmallLoader />
        </div>
      )}
    </div>
  );
}

export default ChatArea;




